import { useCallback } from 'react';
import { Overlay, CompileError, RuntimeError, Header } from '@/components';
import ErrorParams from '@/components/errorParams/ErrorParams';
import { useConnect } from './hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const App = ({
  serverError
}) => {
  const {
    error,
    setError
  } = useConnect(serverError);
  const handleClose = useCallback(() => setError(null), []);
  if (!error) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Overlay, {
    type: error.type,
    animate: !serverError,
    children: [/*#__PURE__*/_jsx(Header, {
      name: error.name,
      message: error.message,
      type: error.type,
      onClose: handleClose,
      hasCloseButton: !serverError
    }), /*#__PURE__*/_jsx(ErrorParams, {
      params: error?.params
    }), error.type === 'compile' && /*#__PURE__*/_jsx(CompileError, {
      error: error
    }), error.type === 'runtime' && /*#__PURE__*/_jsx(RuntimeError, {
      error: error
    })]
  });
};
export default App;